import defaultFilterSet from '../constants/default-new-filter';
import { getCategoryStringFromAppliedFilterType } from './filter-category';
import { getFilterTypeForEditorType } from './filter-type-for-editor-type';
import { filterEditorTypeFromColumnName } from './editor-type-from-column-name';
import { getAdjustedFilterFromEditorTypeChange } from './applied-filter-from-editor-change';
import { getAdjustedAppliedFiltersForIsInternational } from './adjusted-filters-for-commit';
import { defaultHiddenFilterName } from '../constants/filter-set-constants';

export const buildFilterSetForSave = ({
  filterSet,
  sellerHomeCountry,
  filterName = defaultHiddenFilterName,
  filterDescription,
  active,
}) => ({
  ...filterSet,
  appliedFilters: getAdjustedAppliedFiltersForIsInternational(sellerHomeCountry, filterSet.appliedFilters),
  name: filterName,
  description: filterDescription,
  active,
});

export const generateUpdatedAppliedFilters = (newAppliedFilter, appliedFilters = defaultFilterSet.appliedFilters) => {
  const editorType = filterEditorTypeFromColumnName(newAppliedFilter?.column);
  const appliedFilterType = getFilterTypeForEditorType(editorType);
  const categoryUpdatedFilterBelongsTo = getCategoryStringFromAppliedFilterType(appliedFilterType);
  const filtersWithoutUpdatedFilter = Object.keys(appliedFilters).reduce((acc, filterCategory) => {
    return {
      ...acc,
      [filterCategory]: [
        ...appliedFilters[filterCategory].filter((f) => f.workingFilterId && f.workingFilterId !== newAppliedFilter.workingFilterId),
      ],
    };
  }, {});

  const existingFiltersOfTheSameCategory = filtersWithoutUpdatedFilter[categoryUpdatedFilterBelongsTo] || [];
  const updatedAppliedFilters = {
    ...filtersWithoutUpdatedFilter,
    [categoryUpdatedFilterBelongsTo]: [...existingFiltersOfTheSameCategory, newAppliedFilter],
  };
  return updatedAppliedFilters;
};

export const generateFilterSetWithEditorTypeIDs = (editorTypeId, editorTypeValues) => {
  const filter = {
    ...getAdjustedFilterFromEditorTypeChange({}, editorTypeId),
    values: editorTypeValues,
  };
  return {
    appliedFilters: generateUpdatedAppliedFilters(filter),
  };
};
